import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import SystemTaskJobRow from '../SystemTasks/SystemTaskJobRow';
import {Card, CardHeader} from "material-ui/Card";

import SystemTaskJobStore from '../../stores/SystemTaskJobStore';
import TaskActions from '../../actions/SystemTaskActionCreator';

import HistoryIcon from "material-ui/svg-icons/action/history";

class ReportScheduleHistory extends Component {
    componentDidMount() {
        TaskActions.getJobs(this.props.taskId);
    }

    render() {
        const headers = ["Scheduled", "Started", "Finished", "Status"];
        return (
            <Card className="cent-card" key="moduleSegment">
                <CardHeader
                    title="History"
                    avatar={<HistoryIcon/>}
                />
               <Table className="cent-table" selectable={false} multiSelectable={false}>
                   <TableHeader enableSelectAll={false} displaySelectAll={false} adjustForCheckbox={false}>
                       <TableRow>
                           {headers.map((header, i) => <TableHeaderColumn key={i}>{header}</TableHeaderColumn>)}
                       </TableRow>
                   </TableHeader>
                   <TableBody selectable={false} multiSelectable={false} displayRowCheckbox={false}>
                       {this.state.jobs.map((j) => <SystemTaskJobRow row={j} key={j.id} withAuto={false}/>)}
                   </TableBody>
               </Table>
            </Card>
        );
    }
}

ReportScheduleHistory.getStores = () => [SystemTaskJobStore];
ReportScheduleHistory.calculateState = (prevState, {taskId}) => ({
    jobs: SystemTaskJobStore.getJobs(taskId)
})
ReportScheduleHistory.propTypes = {
    taskId: PropTypes.number.isRequired
}
export default Container.create(ReportScheduleHistory, {withProps: true});
